var _style, _g, _path, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.6 74.5",
    style: {
      enableBackground: "new 0 0 211.6 74.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E49A5;}\r\n\t.st1{fill:#F2C162;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-iside-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,73.6V1h11.9v72.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,73.6V1h11.9v72.6H86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.6,73.6h-41V1h41v10h-29.2v19.8h27.3v9.9h-27.3v22.8h29.2V73.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,53.9c0,6.4-2.3,11.5-7,15.2s-11.1,5.5-19.3,5.5s-14.9-1.3-20.1-3.8V59.5c3.3,1.6,6.8,2.8,10.5,3.7 c3.7,0.9,7.2,1.3,10.4,1.3c4.7,0,8.2-0.9,10.4-2.7s3.3-4.2,3.3-7.2c0-2.7-1-5-3.1-6.9s-6.3-4.1-12.7-6.7c-6.6-2.7-11.3-5.7-14-9.2 c-2.7-3.4-4.1-7.6-4.1-12.4c0-6,2.1-10.8,6.4-14.3C38,1.7,43.8,0,51,0c6.9,0,13.9,1.5,20.7,4.6L68,14.2c-6.4-2.7-12.2-4.1-17.3-4.1 c-3.8,0-6.7,0.8-8.7,2.5s-3,3.9-3,6.6c0,1.9,0.4,3.5,1.2,4.8s2.1,2.6,3.9,3.8c1.8,1.2,5.1,2.8,9.8,4.7c5.3,2.2,9.2,4.3,11.7,6.2 c2.5,1.9,4.3,4.1,5.5,6.5C72.2,47.7,72.8,50.6,72.8,53.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.6,34.7c-0.4-9.9-3.8-17.8-10.2-23.6c-6-5.4-13.5-7.7-19.3-8.7c0,0-4.6-0.7-7.1-1 c-4.2-0.4-8.1-0.6-11.7-0.5c3.8,6.5,7.7,13.1,11.5,19.6l2.8-6.9c4.3,0.4,11.2,1.7,16,6.2c4,3.6,6,8.6,6.3,15.3 c0.3,8.7-1.7,15.3-6.1,19.6c-4.1,4.1-10.2,6.3-18.1,6.8c-1.9-2.3-3.8-4.7-5.8-7l-4.4,19.1c2.5,0.2,5.2,0.2,8.3,0 c4-0.3,7.6-0.8,10.6-1.5l0,0c7.2-1.6,13.1-4.6,17.6-9.1C155.9,56.4,159.1,46.8,158.6,34.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 127.1,
    cy: 37.5,
    r: 7.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7777e28769b1a5c7fbb4dd8efd3165d2.svg";
export { ForwardRef as ReactComponent };